import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { keycloakInstance, ensureKeycloakInitialized } from '../keycloak.config';

/**
 * Functional guard for protecting routes based on Keycloak authentication
 * If not authenticated, it can either redirect to login page or trigger login flow
 */
export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  
  console.log('Auth guard check for route:', state.url);
  
  try {
    const authenticated = await ensureKeycloakInitialized();
    console.log('Auth guard check result:', authenticated);
    if (authenticated) {
    console.log('User is authenticated, allowing access to', state.url);
    
    // Extra check for output-meters route to ensure proper flow
    if (route.routeConfig?.path === 'output-meters') {
      const navigation = router.getCurrentNavigation();
      
      if (!navigation || !navigation.extras.state || !navigation.extras.state['meters']) {
        console.log('Unauthorized direct access to output-meters');
        router.navigate(['/input-meters']);
        return false;
      }
    }

    return true;
  }
  
  console.log('User not authenticated, redirecting to landing page');
  router.navigate(['']);
  return false;
} catch (error) {
  console.error('Error in auth guard:', error);
  router.navigate(['']);
  return false;
}
};